import React from 'react';
import { motion } from 'framer-motion';
import { GlobeIcon, LockIcon, ShieldIcon, SparklesIcon, ZapIcon } from 'lucide-react';
import { Button } from './Button';
import { checkoutUrl, ctaLabelSystem, packageContents, trackCheckout } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-cream relative" data-id="element-202" data-mp="1j973mpmlojxv">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-203" data-mp="1nakc77h2v18h">
        <div className="text-center mb-10" data-id="element-204" data-mp="1na0sbl7va2rt">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3 text-navy-deep" data-id="element-205" data-mp="1s9dfk72nhbux">
            Your complete <span className="text-gold" data-id="element-206" data-mp="1x8zuqm21h26d">6-in-1 offer</span> today
          </h2>
          <p className="text-navy-mid text-sm md:text-base" data-id="element-207" data-mp="1x6vt6arm4f99">
            The complete teaching system — ready for your next class.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-cream-beige border-2 border-gold rounded-3xl p-1 relative shadow-[0_24px_60px_-40px_rgba(14,37,67,0.6)]" data-id="element-208" data-mp="2w0goxdb4g17">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold text-white font-bold px-5 py-1.5 rounded-full shadow uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-209" data-mp="1howxrs4eyi7e">
            <SparklesIcon size={14} data-id="element-210" data-mp="17t3c9j8pvedh" /> Complete Package
          </div>
          <div className="bg-cream-card rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-211" data-mp="25g2cg3ymb4g4">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-navy-deep mb-3" data-id="element-212" data-mp="20gfx9oz8be4o">
              Brazilian Jiu-Jitsu Instructor Ready — Complete 6-in-1 Teaching
              System
            </h3>
            <p className="text-base text-ink mb-6" data-id="element-213" data-mp="1rg1asmaj3szl">
              Everything you need to teach Brazilian Jiu-Jitsu with confidence.
            </p>

            <p className="text-xs text-warmgray mb-3 md:hidden" data-id="element-214" data-mp="k3r48mp4lccr">
              ← Scroll to see full table →
            </p>
            <div className="overflow-x-auto mb-6 text-left" data-id="element-215" data-mp="g2p1hvw02i61">
              <table className="w-full text-sm min-w-[460px] border border-gold-light rounded-xl overflow-hidden" data-id="element-216" data-mp="hj2y71r64dgd">
                <thead data-id="element-217" data-mp="mgclobuzyf1k">
                  <tr className="bg-navy-deep text-white" data-id="element-218" data-mp="mei7rhi57n6z">
                    <th scope="col" className="text-left font-bold px-4 py-3 w-12" data-id="element-219" data-mp="7isjfcphixz3">
                      #
                    </th>
                    <th scope="col" className="text-left font-bold px-4 py-3" data-id="element-220" data-mp="ckhw0wscvjpa">
                      Content
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-221" data-mp="3jbc0dqhzqra">
                  {packageContents.map(row => <tr key={row.label} className="border-b border-gold-light last:border-b-0" data-id="element-222" data-mp="3kzjja7gkb9j8">
                      <td className="px-4 py-3 text-lg" aria-hidden="true" data-id="element-223" data-mp="3pymlzl92l3o1">
                        {row.icon}
                      </td>
                      <td className="px-4 py-3 text-ink" data-id="element-224" data-mp="3bzwoi4ic91z5">{row.label}</td>
                    </tr>)}
                </tbody>
              </table>
            </div>

            <div className="mb-6" data-id="element-225" data-mp="2xbmv8f9lj9vy">
              <span className="text-lg text-warmgray line-through block mb-1" data-id="element-226" data-mp="2sc089e3yuf9y">
                $105.00 USD
              </span>
              <div className="flex items-baseline justify-center gap-2" data-id="element-227" data-mp="36c1ktqtlfb59">
                <span className="text-2xl md:text-3xl text-navy-mid" data-id="element-228" data-mp="31con2b16ojnw">TODAY:</span>
                <span className="text-4xl md:text-5xl font-bold text-navy-deep" data-id="element-229" data-mp="31esxlbtl8gx5">
                  $27.00 <span className="text-gold" data-id="element-230" data-mp="3g84iajdi2llv">USD</span>
                </span>
              </div>
            </div>

            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-231" data-mp="3b91oxw6vu3tq">
              {ctaLabelSystem}
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-warmgray mb-4" data-id="element-232" data-mp="2vkmhjf6uikg">
              <span className="flex items-center gap-1.5" data-id="element-233" data-mp="3u370a4vmg1f1">
                <LockIcon size={12} className="text-forest" data-id="element-234" data-mp="hyvx8d3wteoq" /> Secure payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-235" data-mp="lywahuf9vju7">
                <ZapIcon size={12} className="text-forest" data-id="element-236" data-mp="lxbee0db7su8" /> Immediate access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-237" data-mp="qsqqamrrbeo0">
                <ShieldIcon size={12} className="text-forest" data-id="element-238" data-mp="vo62zbe134iu" /> 7-day guarantee
              </span>
            </div>

            <div className="bg-cream-beige border border-gold-light rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-239" data-mp="3v6ffwan0y7m4">
              <GlobeIcon className="text-gold shrink-0 mt-0.5" size={14} data-id="element-240" data-mp="806d0dojji5b" />
              <p className="text-[11px] text-warmgray leading-snug" data-id="element-241" data-mp="81zme0qjggh0">
                🌍 Pay in your local currency. The amount adjusts automatically
                based on the country you purchase from.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}